import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo, faHeartPulse, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
import useAuth from '../../../hooks/useAuth'
const StepOne = ({onValidityChange}) => {
  const [mentalHealthCrisis, setMentalHealthCrisis] = useState(null)
  const [medicalSymptoms, setMedicalSymptoms] = useState(null)
  const { auth } = useAuth();
  const emergencySymptoms = [
    "Severe difficulty breathing",
    "Severe chest pain",
    "Severe abdominal pain",
    "Severe or uncontrolled bleeding",
    "Suspected heart attack or stroke",
    "An infection with dizziness, weakness or confusion (sepsis)",
    "Acute back pain with paralysis of the legs or difficulty using the bladder or bowel",
    "Unexplained loss of consciousness",
    "Uncontrolled seizures or fits",
    "You are pregnant and experiencing pain, bleeding or reduced movement of your baby"
  ]

  useEffect(() => {
    const valid = validate()
    if (typeof onValidityChange === 'function') {
      onValidityChange(valid)
    }
    if(localStorage.getItem('uploadedFiles'))
      {
        localStorage.removeItem('uploadedFiles')
      }
  }, [mentalHealthCrisis, medicalSymptoms])

  const validate = () => {
    return (
      (medicalSymptoms !== null && medicalSymptoms !== true) &&
      (mentalHealthCrisis !== null && mentalHealthCrisis !== true)
    )
  }

  return (
    <div className="max-w-2xl mx-auto p-6 space-y-8 text-portal-dark-blue">
      <div className="border border-blue-400 bg-blue-50 text-blue-800 p-4 rounded-lg flex items-start gap-3">
        <FontAwesomeIcon icon={faCircleInfo} className="mt-1 text-lg" />
        <p className="text-sm">
          You must not use this service for emergencies or urgent conditions, as this may delay necessary treatment.
        </p>
      </div>

      <div>
        <h2 className="font-bold text-lg mb-3">Are you experiencing a mental health crisis or in suicidal distress?</h2>
        <div className="flex gap-6">
          <label className="flex items-center gap-2">
            <input type="radio" name="mentalCrisis" value="no" onChange={() => setMentalHealthCrisis(false)} /> No
          </label>
          <label className="flex items-center gap-2">
            <input type="radio" name="mentalCrisis" value="yes" onChange={() => setMentalHealthCrisis(true)} /> Yes
          </label>
        </div>
      </div>

      <div>
        <h2 className="font-bold text-lg mb-3">Are you experiencing any of the following medical symptoms?</h2>
        <div className="bg-[#F9F9F9] p-4 rounded-lg border">
          <ul className="space-y-2 text-sm text-wba-dark-pink">
            {emergencySymptoms.map((symptom, index) => (
              <li key={index} className="flex items-start gap-2">
                <FontAwesomeIcon icon={faHeartPulse} className="mt-1 " />
                <span>{symptom}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex gap-6 mt-4">
          <label className="flex items-center gap-2">
            <input type="radio" name="symptoms" value="no" onChange={() => setMedicalSymptoms(false)} /> No
          </label>
          <label className="flex items-center gap-2">
            <input type="radio" name="symptoms" value="yes" onChange={() => setMedicalSymptoms(true)} /> Yes
          </label>
        </div>
      </div>

      {(mentalHealthCrisis || medicalSymptoms) && (
        <div className="border border-red-500 bg-red-50 text-red-700 p-4 rounded-lg flex items-start gap-3">
          <FontAwesomeIcon icon={faTriangleExclamation} className="mt-1 text-lg text-red-600" />
          <p className="text-sm">
            Call 999 in the UK or 112 in Europe now. If you are abroad, please contact your local emergency services immediately.
          </p>
        </div>
      )}
    </div>
  )
}

export default StepOne
